exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.signup-link[data-v-431211f5] {\n  font-size: 13px !important;\n  color: #16d1c8 !important;\n  transition: 0.5s !important;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
